import { IconComparador } from '../../components/Icons/IconComparador';
import { IconPending } from '../../components/Icons/IconPending';
import IconPro from '../../components/Icons/IconPro';
import { IconExporterTest } from '../../components/Icons/IconExporterTest';
import { IconCubicaje } from '../../components/Icons/IconCubicaje';
import { IconCalcularPrecios } from '../../components/Icons/IconCalcularPrecios';
import { IconPriceComparator } from '../../components/Icons/IconPriceComparator';
import { IconPreferencias } from '../../components/Icons/IconPreferencias';
import { IconLogo } from '../../components/Icons/IconLogo';
import { IconLogoMobile } from '../../components/Icons/IconLogoMobile';
import { IconLock } from '../../components/Icons/IconLock';
import { IconCirclexmark } from '../../components/Icons/IconCirclexmark';
import { IconPremium } from '../../components/Icons/IconPremium';
import { IconPack } from '../../components/Icons/IconPack';
import { IconNext } from '../../components/Icons/IconNext';
import { IconBack } from '../../components/Icons/IconBack';
import { IconCalculo } from '../../components/Icons/IconCalculo';
import { IconCircleHelper } from '../../components/Icons/IconCircleHelper';
import { IconComparadorSucces } from '../../components/Icons/IconComparadorSucces';
import { IconUserLogged } from '../../components/Icons/IconUserLogged';
import { IconSuscripciones } from '../../components/Icons/IconSuscripciones';
import { IconSuccess } from '../../components/Icons/IconSuccess';
import { IconSeach } from '../../components/Icons/IconSeach';
import { IconMarket } from '../../components/Icons/IconMarket';
import { IconMailSucces } from '../../components/Icons/IconMailSucces';
import { IconInstagram } from '../../components/Icons/IconInstagram';
import { IconLinkedin } from '../../components/Icons/IconLinkedin';
import { IconFlagEs } from '../../components/Icons/IconFlagEs';
import { IconFlagHi } from '../../components/Icons/IconFlagHi';
import { IconFlagEn } from '../../components/Icons/IconFlagEn';
import { IconError } from '../../components/Icons/IconError';
import { IconCompPrecios } from '../../components/Icons/IconCompPrecios';
import { IconClose } from '../../components/Icons/IconClose';
import { IconCkeckSolid } from '../../components/Icons/IconCkeckSolid';
import { IconCkeck } from '../../components/Icons/IconCkeck';
import { IconCircleExclamation } from '../../components/Icons/IconCircleExclamation';
import { IconCartSucces } from '../../components/Icons/IconCartSucces';
import { IconCircleCheck } from '../../components/Icons/IconCircleCheck';
import { IconCart } from '../../components/Icons/IconCart';
import { IconCalcPrecios } from '../../components/Icons/IconCalcPrecios';
import { IconCarret } from '../../components/Icons/IconCarret';
import { IconHerramientas } from '../../components/Icons/IconHerramientas';
import { IconCircleInfo } from '../../components/Icons/IconCircleInfo';
import {
	IconAnalisisPrecios,
	IconDownload,
	IconDropDownArrow,
	IconInformeEU,
	IconSegmentoMarketplace,
	IconSegmentoOnlineStore,
	IconSegmentoSuper,
} from '../../components/Icons';
import { IconAnalisis } from '../../components/Icons/IconAnalisis';
import { IconInformeTecnico } from '../../components/Icons/IconInforme';
import { IconInformeLegal } from '../../components/Icons/IconInformeLegal';
import { IconRelevamientoEU } from '../../components/Icons/IconRelevamientoEU';
import { IconDefinicionesComerciales } from '../../components/Icons/IconDefinicionesComerciales';
import { IconRelevamientoAR } from '../../components/Icons/IconRelevamientoAR';
import { IconExigenciasAduaneras } from '../../components/Icons/IconExigenciasAduaneras';
import { IconInformacionLogistica } from '../../components/Icons/IconInformacionLogistica';
import { IconoAnalisisSanitario } from '../../components/Icons/IconoAnalisisSanitario';
import { IconExigenciaCalidad } from '../../components/Icons/IconExigenciaCalidad';
import { IconRegulatorioEU } from '../../components/Icons/IconRegulatorioEU';
import { IconCompliance } from '../../components/Icons/IconCompliance';
import { IconOtrosLegales } from '../../components/Icons/IconOtrosLegales';
import { IconTools } from '../../components/Icons/IconTools';
import { IconDropDownArrowRounded } from '../../components/Icons/IconDropDownArrowRounded';
import { IconHome } from '../../components/Icons/IconHome';
import { IconPreparacion } from '../../components/Icons/IconPreparacion';
import { IconCostosPrecios } from '../../components/Icons/IconCostosPrecios';
import { IconMercado } from '../../components/Icons/IconMercado';
import { IconNovedades } from '../../components/Icons/IconNovedades';
import { IconSobreNosotros } from '../../components/Icons/IconSobreNosotros';
import { IconTestExportador } from '../../components/Icons/IconTestExportador';
import { IconCompilanceModule } from '../../components/Icons/IconCompilanceModule';
import { IconLimiteDiario } from '../../components/Icons/IconLimiteDiario';
import { IconCalcuFob } from '../../components/Icons/IconCalcuFob';
import { IconCalcuPaletizado } from '../../components/Icons/IconCalcuPaletizado';
import { IconCalcuPrecios } from '../../components/Icons/IconCalcuPrecios';
import IconFeriasInternacionales from '../../components/Icons/IconFeriasInternacionales';
import { IconComparadorPrecios } from '../../components/Icons/IconComparadorPrecios';
import IconNoticias from '../../components/Icons/IconNoticias';
import IconSugerencias from '../../components/Icons/IconSugerencias';
import IconQuienesSomos from '../../components/Icons/IconQuienesSomos';
import IconOtrosServicios from '../../components/Icons/IconOtrosServicios';
import IconHomeExporterTest from '../../components/Icons/IconHomeExporterTest';
import IconHomeCalcularCarga from '../../components/Icons/IconHomeCalcularCarga';
import IconHomePrecioFinal from '../../components/Icons/IconHomePrecioFinal';
import IconHelp from '../../components/Icons/IconHelp';
import { IconSecure } from '../../components/Icons/IconSecure';

export const Icons = () => {
	return (
		<div
			style={{
				padding: '20px',
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
				gap: '20px',
			}}>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconComparador />
				<p>IconComparador</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPending />
				<p>IconPending</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPro />
				<p>IconPro</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconExporterTest />
				<p>IconExporterTest</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCubicaje />
				<p>IconCubicaje</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCalcularPrecios />
				<p>IconCalcularPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPriceComparator />
				<p>IconPriceComparator</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPreferencias />
				<p>IconPreferencias</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconLogo />
				<p>IconLogo</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconLogoMobile />
				<p>IconLogoMobile</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconLock />
				<p>IconLock</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCirclexmark />
				<p>IconCirclexmark</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPremium />
				<p>IconPremium</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPack />
				<p>IconPack</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconNext />
				<p>IconNext</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconBack />
				<p>IconBack</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCalculo />
				<p>IconCalculo</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCircleHelper />
				<p>IconCircleHelper</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconComparadorSucces />
				<p>IconComparadorSucces</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconUserLogged />
				<p>IconUserLogged</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSuscripciones />
				<p>IconSuscripciones</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSuccess />
				<p>IconSuccess</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSeach />
				<p>IconSeach</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconMarket />
				<p>IconMarket</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconMailSucces />
				<p>IconMailSucces</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconInstagram />
				<p>IconInstagram</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconLinkedin />
				<p>IconLinkedin</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconFlagEs />
				<p>IconFlagEs</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconFlagHi />
				<p>IconFlagHi</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconFlagEn />
				<p>IconFlagEn</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconError />
				<p>IconError</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCompPrecios />
				<p>IconCompPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconClose />
				<p>IconClose</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCkeckSolid />
				<p>IconCkeckSolid</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCkeck />
				<p>IconCkeck</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCircleExclamation />
				<p>IconCircleExclamation</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCartSucces />
				<p>IconCartSucces</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCircleCheck />
				<p>IconCircleCheck</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCart />
				<p>IconCart</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCalcPrecios />
				<p>IconCalcPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCarret />
				<p>IconCarret</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconHerramientas />
				<p>IconHerramientas</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCircleInfo />
				<p>IconCircleInfo</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconDownload />
				<p>IconDownload</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSegmentoOnlineStore />
				<p>IconSegmentoOnlineStore</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSegmentoMarketplace />
				<p>IconSegmentoMarketplace</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSegmentoSuper />
				<p>IconSegmentoSuper</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconDropDownArrow />
				<p>IconDropDownArrow</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconAnalisis />
				<p>IconAnalisis</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconInformeTecnico />
				<p>IconInformeTecnico</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconInformeLegal />
				<p>IconInformeLegal</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconRelevamientoEU />
				<p>IconRelevamientoEU</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconRelevamientoAR />
				<p>IconRelevamientoAR</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconInformeEU />
				<p>IconInformeEU</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconAnalisisPrecios />
				<p>IconAnalisisPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconExigenciasAduaneras />
				<p>IconExigenciasAduaneras</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconInformacionLogistica />
				<p>IconInformacionLogistica</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconoAnalisisSanitario />
				<p>IconoAnalisisSanitario</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconExigenciaCalidad />
				<p>IconExigenciaCalidad</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconRegulatorioEU />
				<p>IconRegulatorioEU</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCompliance />
				<p>IconCompliance</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconOtrosLegales />
				<p>IconOtrosLegales</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconTools />
				<p>IconTools</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconDropDownArrowRounded />
				<p>IconDropDownArrowRounded</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconHome />
				<p>IconHome</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconPreparacion />
				<p>IconPreparacion</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCostosPrecios />
				<p>IconCostosPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconMercado />
				<p>IconMercado</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconNovedades />
				<p>IconNovedades</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSobreNosotros />
				<p>IconSobreNosotros</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconTestExportador />
				<p>IconTestExportador</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCompilanceModule />
				<p>IconCompilanceModule</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconLimiteDiario />
				<p>IconLimiteDiario</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCalcuFob />
				<p>IconCalcuFob</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCalcuPaletizado />
				<p>IconCalcuPaletizado</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconCalcuPrecios />
				<p>IconCalcuPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconFeriasInternacionales />
				<p>IconFeriasInternacionales</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconComparadorPrecios />
				<p>IconComparadorPrecios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconNoticias />
				<p>IconNoticias</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSugerencias />
				<p>IconSugerencias</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconQuienesSomos />
				<p>IconQuienesSomos</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconOtrosServicios />
				<p>IconOtrosServicios</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconHomeExporterTest />
				<p>IconHomeExporterTest</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconHomeCalcularCarga />
				<p>IconHomeCalcularCarga</p>
			</div>

			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconHomePrecioFinal />
				<p>IconHomePrecioFinal</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconHelp />
				<p>IconHelp</p>
			</div>
			<div style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}>
				<IconSecure />
				<p>IconSecure</p>
			</div>
		</div>
	);
};
